module.exports = __webpack_public_path__ + "static/media/Zoom Out.75fdcb18.svg";